import { UserSettingsSection } from './userSettings.interface';

const { Config, Dashboards, Reporting, RiskManagement } = UserSettingsSection;

/**
 * Page prefixes of the persisted layout settings (LB-4992): `{page}.layout.{group}`,
 * `{page}.datagrid.columns`, `{page}.sidebar.open`. One entry per page (or per reusable
 * layout) so a page's settings share a prefix across sidebars, panels and grids.
 */
export const UserSettingsPage = {
  ConfigSymbolsCore: `${Config}.symbols.core`,
  ConfigSymbolsClient: `${Config}.symbols.client`,
  ConfigSymbolsClientNode: `${Config}.symbols.client.node`,
  ConfigSymbolsClientServer: `${Config}.symbols.client.server`,
  ConfigSymbolsLp: `${Config}.symbols.lp`,
  ConfigSymbolsSynthetic: `${Config}.symbols.synthetic`,
  ConfigMarkups: `${Config}.markups`,
  ConfigMarkupsIndex: `${Config}.markups.index`,
  ConfigMarkupsProfile: `${Config}.markups.profile`,
  ConfigSettingsServers: `${Config}.settings.servers`,
  ConfigSettingsStreams: `${Config}.settings.streams`,
  ConfigSettingsUsers: `${Config}.settings.users`,
  ConfigSettingsLps: `${Config}.settings.lps`,
  ConfigSettingsAlerts: `${Config}.settings.alerts`,
  ConfigProfiles: `${Config}.profiles`,
  ConfigProfilesPricing: `${Config}.profiles.pricing`,
  ConfigProfilesPriceFiltering: `${Config}.profiles.price-filtering`,
  ConfigProfilesOrderLifetime: `${Config}.profiles.order-lifetime`,
  ConfigProfilesAdjustment: `${Config}.profiles.adjustment`,
  ConfigProfilesSpread: `${Config}.profiles.spread`,
  ConfigProfilesRouting: `${Config}.profiles.routing`,
  ConfigProfilesSchedule: `${Config}.profiles.schedule`,
  ConfigRulesPricing: `${Config}.rules.pricing`,
  ConfigRulesPriceFiltering: `${Config}.rules.price-filtering`,
  ConfigRulesRouting: `${Config}.rules.routing`,
  ConfigRulesOrderLifetime: `${Config}.rules.order-lifetime`,
  ConfigRulesAdjustment: `${Config}.rules.adjustment`,
  ConfigExternalReporting: `${Config}.external-reporting`,
  ConfigExternalReportingReports: `${Config}.external-reporting.reports`,
  ConfigExternalReportingServers: `${Config}.external-reporting.servers`,
  DashboardsAlerts: `${Dashboards}.alerts`,
  DashboardsConnectionStatusLps: `${Dashboards}.connection-status.lps`,
  DashboardsConnectionStatusServers: `${Dashboards}.connection-status.servers`,
  DashboardsInfrastructureStatus: `${Dashboards}.infrastructure-status`,
  DashboardsExposure: `${Dashboards}.exposure`,
  DashboardsPrices: `${Dashboards}.prices`,
  DashboardsPricesServer: `${Dashboards}.prices.server`,
  DashboardsPricesLp: `${Dashboards}.prices.lp`,
  ReportingOrders: `${Reporting}.orders`,
  ReportingConversionRates: `${Reporting}.conversion-rates`,
  RiskManagementMarkout: `${RiskManagement}.markout`,
} as const;

export type TUserSettingsPage = (typeof UserSettingsPage)[keyof typeof UserSettingsPage];
